import { render, staticRenderFns } from "./SectionBar.vue?vue&type=template&id=194d1346&"
import script from "./SectionBar.vue?vue&type=script&lang=ts&"
export * from "./SectionBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports